import { render, staticRenderFns } from "./channelAdd.vue?vue&type=template&id=ce9a2166"
import script from "./channelAdd.vue?vue&type=script&lang=js"
export * from "./channelAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports